import React from 'react';
import {
  FieldProps,
  ErrorMessage,
} from 'formik';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

import {
  Flex,
} from 'web-styled';

import {
  TextInput,
} from 'web-components';

import * as S from './styled';

export type InputProps = {
  flex: string;
  label: any;
  color: string;
  width?: string;
  height?: string;
  spacing?: number;
  margin?: string;
  placeholder?: string;
  textarea?: boolean,
  className?: string;
  dateFormat?: string;
  onChange: { (value: any): void };
} & FieldProps;

// DatePicker customInput require a class
// eslint-disable-next-line
class CustomInput extends React.Component {
  render() {
    return (
      <TextInput
        {...this.props}
      />
    );
  }
}

const DatePickerField = ({
  label,
  field,
  form: { touched, errors, setFieldValue },
  flex,
  width,
  spacing,
  color,
  dateFormat,
  onChange,
  ...rest
}: InputProps) => {
  const iserror = (touched[field.name] && errors[field.name]);

  return (
    <Flex
      column
      width={width}
      spacing={spacing}
      flex={flex}
    >
      {label && (
        <S.Label
          htmlFor={`${field.name}-id`}
          color={color}
        >
          {label}
        </S.Label>
      )}
      <S.DatePickerWrapper>
        <DatePicker
          {...rest}
          selected={
            field.value
              ? new Date(field.value)
              : null
          }
          onChange={(value) => {
            if (onChange) {
              onChange(value);
            } else {
              setFieldValue(
                field.name,
                value,
              );
            }
          }}
          customInput={<CustomInput iserror={iserror} />}
          dateFormat={dateFormat}
        />
      </S.DatePickerWrapper>
      <ErrorMessage
        name={field.name}
        component={S.Error}
      />
    </Flex>
  );
};

DatePickerField.defaultProps = {
  label: null,
  spacing: 10,
  width: '100%',
  dateFormat: 'MM/dd/yyyy',
};

export default DatePickerField;
